import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { doc, onSnapshot } from 'firebase/firestore';
import PublicLayout from '../../components/public/PublicLayout';
import PageHero from '../../components/public/PageHero';
import { db } from '../../firebase';
import { normalizeFacultiesContent } from '../../publicSite/facultyContent';
import { faculties as defaultFaculties } from '../../publicSite/facultyData';
import { usePageMeta } from '../../publicSite/usePageMeta';
import { withBase } from '../../publicSite/config';

export default function Faculties() {
  usePageMeta(
    'Academics | School of Shem',
    'Explore School of Shem academic faculties and their practical, faith-aligned learning pathways.'
  );
  const useFirebase = process.env.REACT_APP_USE_FIREBASE === 'true';
  const [faculties, setFaculties] = useState(() => normalizeFacultiesContent(defaultFaculties));

  useEffect(() => {
    if (!useFirebase) return undefined;
    const unsubscribe = onSnapshot(
      doc(db, 'settings', 'publicSite'),
      (snapshot) => {
        const saved = snapshot.exists() ? snapshot.data()?.facultiesContent : null;
        setFaculties(normalizeFacultiesContent(saved || defaultFaculties));
      },
      () => setFaculties(normalizeFacultiesContent(defaultFaculties))
    );
    return () => unsubscribe();
  }, [useFirebase]);

  return (
    <PublicLayout>
      <PageHero
        eyebrow="Academic pathways"
        title="Academics"
        subtitle="Explore School of SHEM academic offerings and find the faculty aligned with the domain you are ready to strengthen."
        image="/images/shem-academics-masterclass.jpg"
        imageAlt="A mentor leading an intimate School of SHEM learning session"
      />

      <section className="ps-section">
        <div className="ps-section-inner">
          {faculties.length > 0 ? (
            <div className="public-faculty-grid">
              {faculties.map((faculty, index) => (
                <article className="public-faculty-card" key={faculty.slug}>
                  {faculty.logo && (
                    <Link
                      className="public-faculty-media"
                      to={withBase(`/academics/faculties/${faculty.slug}`)}
                      aria-label={`Explore ${faculty.title}`}
                    >
                      <img src={faculty.logo} alt="" loading="lazy" />
                    </Link>
                  )}
                  <div className="public-faculty-card-index">{String(index + 1).padStart(2, '0')}</div>
                  <div className="ps-hero-eyebrow">Faculty</div>
                  <h2>{faculty.title}</h2>
                  <p>{faculty.summary}</p>
                  <Link className="public-text-link" to={withBase(`/academics/faculties/${faculty.slug}`)}>
                    Explore faculty <span aria-hidden="true">→</span>
                  </Link>
                </article>
              ))}
            </div>
          ) : (
            <p className="ps-empty-state">Academic faculties will be published here soon.</p>
          )}
        </div>
      </section>
    </PublicLayout>
  );
}
